import { ShieldCheck, KeyRound, FileText, UserCheck } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const POINT_ICONS = [KeyRound, FileText, UserCheck];

export const BusFactorSection = () => {
  const { t } = useLang();
  const b = t.busFactor;
  return (
    <section id="ownership" className="relative scroll-mt-24 py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid bg-grid-fade pointer-events-none" style={{ zIndex: 0 }} />
      <div
        className="glow-orb animate-glow pointer-events-none"
        style={{ zIndex: 0, width: 460, height: 360, top: -40, left: "-4%", background: "var(--green)", opacity: 0.12 }}
      />
      <div className="relative z-10 mx-auto max-w-5xl px-5">
        <div className="glass-card depth-card sheen rounded-3xl p-8 lg:p-12" data-testid="busfactor-section">
          <div className="flex items-center gap-2.5 mb-5">
            <span className="grid place-items-center h-9 w-9 rounded-xl border border-[rgba(54,226,160,0.3)] bg-[rgba(54,226,160,0.08)] text-[var(--green)]">
              <ShieldCheck size={18} />
            </span>
            <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-[var(--green)]">{b.eyebrow}</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl font-semibold text-white leading-tight" data-testid="busfactor-title">
            {b.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-muted leading-relaxed max-w-3xl" data-testid="busfactor-body">
            {b.body}
          </p>
          <div className="mt-9 grid sm:grid-cols-3 gap-4" data-testid="busfactor-points">
            {b.points.map((p, i) => {
              const Icon = POINT_ICONS[i] || ShieldCheck;
              return (
                <div key={i} className="glass rounded-2xl p-5 flex items-start gap-3" data-testid={`busfactor-point-${i}`}>
                  <span className="grid place-items-center h-9 w-9 shrink-0 rounded-lg bg-[rgba(54,226,160,0.1)] text-[var(--green)]">
                    <Icon size={17} />
                  </span>
                  <p className="text-sm text-white/90 leading-snug">{p}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
